import { defineComponent as _defineComponent } from 'vue'
import Overlay from "#src/components/Overlay.vue";

// export default Vue.extend({
//   components: { Overlay }
// });

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalOverlay',
  setup(__props, { expose: __expose }) {
  __expose();

// import Vue from "vue";


const __returned__ = { Overlay }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})